/** Prefix of every `analysisRunFiles` query key. Its own module so
 *  `useReportProgress` (which invalidates it when a PDF report completes)
 *  does not pull in the analysis registry. */
export const ANALYSIS_RUN_FILES_KEY = 'analysisRunFiles';
